export interface IInner {}

export interface IOutter {}

export type IProps = IInner & IOutter;

export enum ESearchType {
	TITLE = 'TITLE',
	STATUS = 'STATUS',
	TYPE = 'TYPE',
	TARGET_UNIT_ID = 'TARGET_UNIT_ID',
	REGIST_NAME = 'REGIST_NAME',
	REGIST_DT = 'REGIST_DT',
}

export enum EStatusTypeText {
	WAIT_REPLY = '답변대기',
	REPLIED = '답변 완료',
}
